// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { FileZipIcon as FileZipGlyph } from "@phosphor-icons/react/dist/ssr/FileZip";
import { FilesIcon as FilesGlyph } from "@phosphor-icons/react/dist/ssr/Files";
import { FingerprintIcon as FingerprintGlyph } from "@phosphor-icons/react/dist/ssr/Fingerprint";
import { FlagIcon as FlagGlyph } from "@phosphor-icons/react/dist/ssr/Flag";
import { FloppyDiskIcon as FloppyDiskGlyph } from "@phosphor-icons/react/dist/ssr/FloppyDisk";
import { FolderLockIcon as FolderLockGlyph } from "@phosphor-icons/react/dist/ssr/FolderLock";
import { FolderOpenIcon as FolderOpenGlyph } from "@phosphor-icons/react/dist/ssr/FolderOpen";
import { FolderPlusIcon as FolderPlusGlyph } from "@phosphor-icons/react/dist/ssr/FolderPlus";
import { FolderSimpleIcon as FolderSimpleGlyph } from "@phosphor-icons/react/dist/ssr/FolderSimple";
import { ForkKnifeIcon as ForkKnifeGlyph } from "@phosphor-icons/react/dist/ssr/ForkKnife";
import { FunnelIcon as FunnelGlyph } from "@phosphor-icons/react/dist/ssr/Funnel";
import { FunnelSimpleIcon as FunnelSimpleGlyph } from "@phosphor-icons/react/dist/ssr/FunnelSimple";
import { GaugeIcon as GaugeGlyph } from "@phosphor-icons/react/dist/ssr/Gauge";
import { GearIcon as GearGlyph } from "@phosphor-icons/react/dist/ssr/Gear";
import { GitMergeIcon as GitMergeGlyph } from "@phosphor-icons/react/dist/ssr/GitMerge";
import { GlobeIcon as GlobeGlyph } from "@phosphor-icons/react/dist/ssr/Globe";
import { GlobeHemisphereWestIcon as GlobeHemisphereWestGlyph } from "@phosphor-icons/react/dist/ssr/GlobeHemisphereWest";
import { GraduationCapIcon as GraduationCapGlyph } from "@phosphor-icons/react/dist/ssr/GraduationCap";
import { GridFourIcon as GridFourGlyph } from "@phosphor-icons/react/dist/ssr/GridFour";
import { HammerIcon as HammerGlyph } from "@phosphor-icons/react/dist/ssr/Hammer";
import { HandCoinsIcon as HandCoinsGlyph } from "@phosphor-icons/react/dist/ssr/HandCoins";
import { HandshakeIcon as HandshakeGlyph } from "@phosphor-icons/react/dist/ssr/Handshake";
import { HardDriveIcon as HardDriveGlyph } from "@phosphor-icons/react/dist/ssr/HardDrive";
import { HeadsetIcon as HeadsetGlyph } from "@phosphor-icons/react/dist/ssr/Headset";
import { HeartIcon as HeartGlyph } from "@phosphor-icons/react/dist/ssr/Heart";
import { HeartbeatIcon as HeartbeatGlyph } from "@phosphor-icons/react/dist/ssr/Heartbeat";
import { HouseIcon as HouseGlyph } from "@phosphor-icons/react/dist/ssr/House";
import { HouseLineIcon as HouseLineGlyph } from "@phosphor-icons/react/dist/ssr/HouseLine";
import { ImageIcon as ImageGlyph } from "@phosphor-icons/react/dist/ssr/Image";
import { ImageBrokenIcon as ImageBrokenGlyph } from "@phosphor-icons/react/dist/ssr/ImageBroken";
import { ImageSquareIcon as ImageSquareGlyph } from "@phosphor-icons/react/dist/ssr/ImageSquare";
import { InfoIcon as InfoGlyph } from "@phosphor-icons/react/dist/ssr/Info";
import { InstagramLogoIcon as InstagramLogoGlyph } from "@phosphor-icons/react/dist/ssr/InstagramLogo";
import { KanbanIcon as KanbanGlyph } from "@phosphor-icons/react/dist/ssr/Kanban";
import { KeyIcon as KeyGlyph } from "@phosphor-icons/react/dist/ssr/Key";

export const FileZip = /* @__PURE__ */ createAppIcon(FileZipGlyph, "FileZip");
export const Files = /* @__PURE__ */ createAppIcon(FilesGlyph, "Files");
export const Fingerprint = /* @__PURE__ */ createAppIcon(
  FingerprintGlyph,
  "Fingerprint",
);
export const Flag = /* @__PURE__ */ createAppIcon(FlagGlyph, "Flag");
export const FloppyDisk = /* @__PURE__ */ createAppIcon(
  FloppyDiskGlyph,
  "FloppyDisk",
);
export const FolderLock = /* @__PURE__ */ createAppIcon(
  FolderLockGlyph,
  "FolderLock",
);
export const FolderOpen = /* @__PURE__ */ createAppIcon(
  FolderOpenGlyph,
  "FolderOpen",
);
export const FolderPlus = /* @__PURE__ */ createAppIcon(
  FolderPlusGlyph,
  "FolderPlus",
);
export const FolderSimple = /* @__PURE__ */ createAppIcon(
  FolderSimpleGlyph,
  "FolderSimple",
);
export const ForkKnife = /* @__PURE__ */ createAppIcon(
  ForkKnifeGlyph,
  "ForkKnife",
);
export const Funnel = /* @__PURE__ */ createAppIcon(FunnelGlyph, "Funnel");
export const FunnelSimple = /* @__PURE__ */ createAppIcon(
  FunnelSimpleGlyph,
  "FunnelSimple",
);
export const Gauge = /* @__PURE__ */ createAppIcon(GaugeGlyph, "Gauge");
export const Gear = /* @__PURE__ */ createAppIcon(GearGlyph, "Gear");
export const GitMerge = /* @__PURE__ */ createAppIcon(
  GitMergeGlyph,
  "GitMerge",
);
export const Globe = /* @__PURE__ */ createAppIcon(GlobeGlyph, "Globe");
export const GlobeHemisphereWest = /* @__PURE__ */ createAppIcon(
  GlobeHemisphereWestGlyph,
  "GlobeHemisphereWest",
);
export const GraduationCap = /* @__PURE__ */ createAppIcon(
  GraduationCapGlyph,
  "GraduationCap",
);
export const GridFour = /* @__PURE__ */ createAppIcon(
  GridFourGlyph,
  "GridFour",
);
export const Hammer = /* @__PURE__ */ createAppIcon(HammerGlyph, "Hammer");
export const HandCoins = /* @__PURE__ */ createAppIcon(
  HandCoinsGlyph,
  "HandCoins",
);
export const Handshake = /* @__PURE__ */ createAppIcon(
  HandshakeGlyph,
  "Handshake",
);
export const HardDrive = /* @__PURE__ */ createAppIcon(
  HardDriveGlyph,
  "HardDrive",
);
export const Headset = /* @__PURE__ */ createAppIcon(HeadsetGlyph, "Headset");
export const Heart = /* @__PURE__ */ createAppIcon(HeartGlyph, "Heart");
export const Heartbeat = /* @__PURE__ */ createAppIcon(
  HeartbeatGlyph,
  "Heartbeat",
);
export const House = /* @__PURE__ */ createAppIcon(HouseGlyph, "House");
export const HouseLine = /* @__PURE__ */ createAppIcon(
  HouseLineGlyph,
  "HouseLine",
);
export const Image = /* @__PURE__ */ createAppIcon(ImageGlyph, "Image");
export const ImageBroken = /* @__PURE__ */ createAppIcon(
  ImageBrokenGlyph,
  "ImageBroken",
);
export const ImageSquare = /* @__PURE__ */ createAppIcon(
  ImageSquareGlyph,
  "ImageSquare",
);
export const Info = /* @__PURE__ */ createAppIcon(InfoGlyph, "Info");
export const InstagramLogo = /* @__PURE__ */ createAppIcon(
  InstagramLogoGlyph,
  "InstagramLogo",
);
export const Kanban = /* @__PURE__ */ createAppIcon(KanbanGlyph, "Kanban");
export const Key = /* @__PURE__ */ createAppIcon(KeyGlyph, "Key");
